exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/hkk/source/crazyaboutmath/src/app/menu/menu.component.css
// module id = ../../../../../src/app/menu/menu.component.css
// module chunks = main